import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { t } from '@lingui/macro';
import css from './time-ticker.scss';
import { useTimer } from './time-ticker-hooks';
import { handInQtc } from '../mle/mle-actions';
import { ModalGeneric } from '../../components/modal-content';
import { constructModal, activateModal } from '../modal/modal-actions';
import { useLocalisation } from '../../helpers/i18n/use-localisation';
import { countAnswered } from '../progress-info/progress-info-utils';
import { leaveMle } from '../../helpers/utils';

const TimeTicker = ({
  className
}) => {
  const {
    timeLeftInSeconds,
    isCompleted,
    questions
  } = useSelector(state => state.mleReducer);
  const dispatch = useDispatch();
  const { i18n } = useLocalisation();

  const [tick] = useTimer({ timeLeft: timeLeftInSeconds, isCompleted });

  const expirationModal = () => {
    const isAssessmentAttempted = countAnswered(questions) > 0;

    if (isAssessmentAttempted) {
      dispatch(handInQtc());
    }

    const modalData = {
      subHeader: i18n._(t`Time is up.`),
      paragraph: i18n._(
        isAssessmentAttempted ?
          t`Your assessment has been handed in.` :
          // eslint-disable-next-line max-len
          t`You didn't answer any questions, so your assessment was not submitted. It will remain in your To-do list for you to complete`
      ),
      buttons: [
        {
          text: i18n._(t`OK`),
          callBack: () => {
            dispatch(activateModal(false));
            if (!isAssessmentAttempted) {
              leaveMle('Time is up - no questions answered');
            }
          },
          size: 'large'
        }
      ]
    };

    dispatch(constructModal({
      activate: true,
      content: <ModalGeneric modalData={modalData} />,
      canvasOnClick: false
    }));
  };

  useEffect(() => {
    if (tick === '00:00' && !isCompleted) {
      expirationModal();
    }
  }, [tick]);

  return (
    <div className={classNames(css['time-ticker'], className)}>
      {tick}
    </div>
  );
};

TimeTicker.propTypes = {
  className: PropTypes.string
};

export default TimeTicker;
